var isBrowser = new Function("try {return this===window;}catch(e){ return false;}")

class StoreManager {
  constructor({
    createWorker,
    onStart,
    onClose,
    readIndex,
    writeIndex,
    updateAllStore,
    errorHandler = function (err) {
      console.log(err)
    }
  }) {
    this.index = {};
    this.readIndex = readIndex.bind(this);
    this.writeIndex = writeIndex.bind(this);
    if (updateAllStore) {
      this.updateAllStore = updateAllStore.bind(this)
    }
    this.errorHandler = errorHandler.bind(this);
    this.onStart = onStart?.bind(this)
    this.onClose = onClose?.bind(this)

    this.worker = null
    this.createWorker = createWorker

    this.onUpdate = (data) => {
      try {
        this.updateAllStore(data)
      } catch (err) {
        this.errorHandler(err)
      }
    }
  }

  updateAll(next = {}) {
    // read the previous entry in index
    let prev = this.readIndex() || {}
    this.writeIndex(next);
    this.worker.postMessage({ prev, next })
  }

  start(index) {
    this.worker = this.createWorker()
    if (isBrowser()) {
      this.worker.onmessage = event => {
        this.onUpdate(event.data)
      }
    } else {
      this.worker.on("message", (data) => {
        this.onUpdate(data)
      })
    }
    this.onStart?.(index)
  }

  close() {
    this.worker.terminate();
    this.onClose?.()
  }
}

module.exports = StoreManager
